//#region src/engine/modules/table-group/actions.ts
var ActionType = {
	addTableGroup: "tableGroup.add",
	moveTableGroup: "tableGroup.move",
	moveToTableGroup: "tableGroup.moveTo",
	removeTableGroup: "tableGroup.remove",
	resizeTableGroup: "tableGroup.resize",
	changeTableGroupName: "tableGroup.changeName",
	changeTableGroupColor: "tableGroup.changeColor",
	changeTableGroupZIndex: "tableGroup.changeZIndex"
};
//#endregion
export { ActionType };
